







































import { FeedStateModule } from '@/store/feed';
import { FeedModel } from '@/type/api';
import { CommentModel } from '@/type/api/comment';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserStateModule } from '@/store';
import { ServiceHelper } from '../../../util';
import { ActivityService } from '@/kuroco_api/services/ActivityService';
import { maxlengthContentEditable } from 'maxlength-contenteditable';

@Component<FeedContentCommentForm>({})
export default class FeedContentCommentForm extends Vue {
  // PROPS
  @Prop()
  feed!: FeedModel.Read.Response.Feed;

  // FIELDS
  UserStateModule = UserStateModule;

  // METHODS
  checkOverMaxLength(e: any) {
    const len = (() => {
      const passed =
        e.data?.trim().length ||
        e.clipboardData?.getData('Text')?.trim().length ||
        (window as any).clipboardData?.getData('Text')?.trim().length ||
        0;
      const content = e.target.innerText.length;

      return passed + content;
    })();

    if (len > 140) {
      this.$snack.danger({ text: this.$t('place_holder') });
    }
  }
  async addComment(feed: FeedModel.Read.Response.Feed) {
    const note = (this.$refs.editable as any).innerText.trim() as string;

    const comment: ActivityService.postActivityServiceRcmsApi1CommentCreateRequest = {
      requestBody: {
        note,
        name: UserStateModule.selfUser.nickname as string,
        module_id: feed.topics_id,
      },
    };

    await FeedStateModule.createComment(comment).then(() => {
      (this.$refs.editable as any).innerText = '';
      this.$emit('commit-change');
    });
  }

  // LYFECYCLE HOOKS
  mounted() {
    /**
     * executes maxlength attribute for contenteditable div element.
     * @see https://github.com/stephen31/maxlength-contenteditable
     */
    maxlengthContentEditable();
  }
}
